import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { LessorRepresentativeDto, LessorInfoDto, LessorRepTypeDto, BankDto, AddressBookDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-lessor-representative-table',
  templateUrl: './lessor-representative-table.component.html',
  styleUrls: ['./lessor-representative-table.component.scss']
})
export class LessorRepresentativeTableComponent implements OnChanges {


  @Input() lessorRepresentatives: LessorRepresentativeDto[];
  @Input() selectedLessorInfo: LessorInfoDto;
  @Input() banks: BankDto[];
  @Input() addressBook: AddressBookDto[];
  @Input() lessorRepTypes: LessorRepTypeDto[];
  @Output() emitEdit = new EventEmitter<any>();
  lessorRepresentativeArrayForm: FormGroup;
  selectedIndex = null;
  filteredDelete = [];
  listView = false;
  gridView = true;

  constructor(private fb: FormBuilder) { }

  ngOnChanges(): void {
    this.lessorRepresentativeArrayForm = this.fb.group({LessorRepresentative: this.fb.array([])});
    if(
      this.lessorRepresentatives != null &&
      this.lessorRepresentatives.length &&
      this.addressBook != null && this.addressBook.length) {
      this.filterRepresentative(this.selectedLessorInfo);
    }

  }


  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

  getAddressBook(id: string) {
    const foundAddressBook = this.addressBook.find(item => item.id === id);
    return foundAddressBook ? foundAddressBook : {};
  }



  filterRepresentative(selectedLessorInfo: LessorInfoDto) {
    const filteredLessorRepresentative = this.lessorRepresentatives.filter(item => item.LessorsId === selectedLessorInfo.id);
    if(filteredLessorRepresentative != null && filteredLessorRepresentative.length) {
      const transformedLessorRepresentative = filteredLessorRepresentative.map(item => {
        return {
          addressBook: {
            BankName: this.getBankName(this.getAddressBook(item.AddressBookId)['BankId']),
            ...this.getAddressBook(item.AddressBookId)
          },
          ...item
        }
     });
      this.setLessorRepresentative(transformedLessorRepresentative);
    }
  }


  get lessorRepresentativeFormArray() {
    return this.lessorRepresentativeArrayForm.get('LessorRepresentative') as FormArray;
  }

  onEdit(value, index) {
    this.selectedIndex = index;
    value['index'] = index;
    this.emitEdit.emit(value);
  }


  setLessorRepresentative(lessorRepresentatives: any[]) {
    lessorRepresentatives.forEach(lessor => {
      this.lessorRepresentativeFormArray.push(this.fb.group({
        Name: lessor.addressBook.Name,
        PhoneNo: lessor.addressBook.PhoneNo,
        Address: lessor.addressBook.Address,
        AccountNo: lessor.addressBook.AccountNo,
        BankId: lessor.addressBook.BankId,
        LessorRepTypeId: lessor.LessorRepTypeId,
        FromDate: lessor.FromDate,
        ToDate: lessor.ToDate,
        AddressBookId: lessor.AddressBookId,
        LandTitleId: lessor.LandTitleId,
        LessorsId: lessor.LessorsId,
        id: lessor.id


      }));
    });
  }


  addLessorRepresentative(lessor: any) {
  this.lessorRepresentativeFormArray.insert(0, this.fb.group({
      Name: lessor.Name,
      PhoneNo: lessor.PhoneNo,
      Address: lessor.Address,
      AccountNo: lessor.AccountNo,
      BankId: lessor.BankId,
      LessorRepTypeId: lessor.LessorRepTypeId,
      FromDate: lessor.FromDate,
      ToDate: lessor.ToDate,
      LessorsId: lessor.LessorsId,
      AddressBookId: lessor.AddressBookId,
      LandTitleId: this.selectedLessorInfo.LandTitleId,
      }));
  }


  onDelete(value, index: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        // this.dispatchDelete.emit(id);
        this.lessorRepresentativeFormArray.removeAt(index);
        if(value.id != null) {
          this.filteredDelete.push(value.id);
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }



  getLessorRepTypeName(id: string) {
    const found = this.lessorRepTypes.find(item => item.id === id);
    return found ? found.LessorRepName : '';
  }

  getBankName(id: string) {
    const found = this.banks.find(item => item.id === id);
    return found ? found.BankName : '';
  }


}
